require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./feature-pete-tong-the-heritage-orchestra-ibiza-classics.json") })
        }
      }, "path---feature-pete-tong-the-heritage-orchestra-ibiza-classics");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---feature-pete-tong-the-heritage-orchestra-ibiza-classics!./.cache/json/feature-pete-tong-the-heritage-orchestra-ibiza-classics.json
// module id = 645
// module chunks = 231608221292675